import { render, staticRenderFns } from "./FindPwd.vue?vue&type=template&id=0a6308a5"
import script from "./FindPwd.vue?vue&type=script&lang=js"
export * from "./FindPwd.vue?vue&type=script&lang=js"
import style0 from "./FindPwd.vue?vue&type=style&index=0&id=0a6308a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports